<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<!--Usage guideline: Wrap this directive inside a div that has a class with the following properties:
    .list-insert-item {
        display: flex;
        width: 100%;
    }
    assuming it's parent has some width defined.

    Example:
    <div class="list-insert-item">
        <nv-hig-list-insert [data]="data"></nv-hig-list-insert>
    </div>
-->

<div
    class="nv-hig-list-insert-container"
    [ngClass]="data?.colorTheme"
    [attr.role]="data?.ariaRole"
    [attr.aria-label]="computedAriaLabel"
>
    <!-- 1. First div: Optional left white solid border of 4px -->
    @if (data.isLeftBorder) {
        <div class="left-border"></div>
    }
    @if (data.leadIcon) {
        <!-- 2. Second div: Icon placed centrally -->
        <div class="lead-icon" [class]="textColor">
            <mat-icon svgIcon="{{ data.leadIcon }}"></mat-icon>
        </div>
    }

    <div class="core-container">
        @if (data.headerText || data.supportingText) {
            <!-- 3. Third div: Header and supporting text -->
            <div
                [class.text-content]="data.headerText && data.supportingText"
                [class.supporting-text-only]="!data.headerText"
            >
                @if (data.headerText) {
                    <span
                        class="header-text font-body1"
                        [class]="textColor"
                        [innerHtml]="
                            data.headerText.translated
                                ? data.headerText.text
                                : (data.headerText.text | translate: data.headerText.placeholders)
                        "
                    ></span>
                }
                @if (data.supportingText) {
                    <span
                        class="font-body2"
                        [class]="textColor"
                        cdkMonitorSubtreeFocus
                        [innerHtml]="
                            data.supportingText.translated
                                ? data.supportingText.text
                                : (data.supportingText.text | translate: data.supportingText.placeholders)
                        "
                    ></span>
                }
            </div>
        }
        @if (data.primaryButtonText || data.secondaryButtonText) {
            <!-- 4. Fourth div: Two mat-buttons -->
            <div class="buttons-group">
                @if (data.primaryButtonText) {
                    <button mat-button class="font-button2" (click)="onPrimaryButtonClick($event)" cdkFocusInitial>
                        {{ data.primaryButtonText | translate: data.primaryButtonTextParams }}
                        @if (data.primaryButtonIcon) {
                            <mat-icon svgIcon="{{ data.primaryButtonIcon }}" aria-hidden="true"></mat-icon>
                        }
                    </button>
                }
                @if (data.secondaryButtonText) {
                    <button mat-button class="font-button2" (click)="onSecondaryButtonClick($event)" cdkFocusInitial>
                        {{ data.secondaryButtonText | translate }}
                    </button>
                }
            </div>
        }
    </div>

    @if (data.iconButton) {
        <!-- 5. Fifth div: Icon button -->
        <div
            class="icon-button"
            [class.icon-button-when-supporting-text-only]="!data.headerText && data.supportingText"
        >
            <button mat-icon-button (click)="onIconButtonClick($event)">
                <mat-icon svgIcon="{{ data.iconButton }}"></mat-icon>
            </button>
        </div>
    }
</div>
